// src/components/preferences/WorkStylePreferenceEditor.tsx
/**
 * Editor for work style preferences (work hours, team size, autonomy, meetings)
 * ⚠️ FIXED: Uses correct field names matching backend schema
 */
import React from 'react';
import {
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonList,
} from '@ionic/react';
import {
  WorkStylePreferences,
  WORK_HOURS,
  TEAM_SIZES,
  AUTONOMY_LEVELS,
  MEETING_CULTURES,
} from '../../types/preferences.ts';
import './PreferenceEditor.css';

interface WorkStylePreferenceEditorProps {
  data: WorkStylePreferences;
  onChange: (data: WorkStylePreferences) => void;
}

const WorkStylePreferenceEditor: React.FC<WorkStylePreferenceEditorProps> = ({ data, onChange }) => {
  const handleFieldChange = (field: keyof WorkStylePreferences, value: any) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <IonList className="preference-editor-list">
      <IonItem>
        <IonLabel position="stacked">
          <h3>Work Hours Preference</h3>
          <p>How you prefer to structure your work schedule</p>
        </IonLabel>
        <IonSelect
          value={data.work_hours || ''}
          placeholder="Select work hours preference"
          onIonChange={(e) => handleFieldChange('work_hours', e.detail.value)}
        >
          {WORK_HOURS.map((option) => (
            <IonSelectOption key={option.value} value={option.value}>
              {option.label}
            </IonSelectOption>
          ))}
        </IonSelect>
      </IonItem>

      <IonItem>
        <IonLabel position="stacked">
          <h3>Preferred Team Size</h3>
          <p>Ideal number of people on your team</p>
        </IonLabel>
        <IonSelect
          value={data.team_size || ''}
          placeholder="Select team size"
          onIonChange={(e) => handleFieldChange('team_size', e.detail.value)}
        >
          {TEAM_SIZES.map((option) => (
            <IonSelectOption key={option.value} value={option.value}>
              {option.label}
            </IonSelectOption>
          ))}
        </IonSelect>
      </IonItem>

      <IonItem>
        <IonLabel position="stacked">
          <h3>Autonomy Level</h3>
          <p>How much independence you prefer in your work</p>
        </IonLabel>
        <IonSelect
          value={data.autonomy_level || ''}
          placeholder="Select autonomy level"
          onIonChange={(e) => handleFieldChange('autonomy_level', e.detail.value)}
        >
          {AUTONOMY_LEVELS.map((option) => (
            <IonSelectOption key={option.value} value={option.value}>
              {option.label}
            </IonSelectOption>
          ))}
        </IonSelect>
      </IonItem>

      <IonItem>
        <IonLabel position="stacked">
          <h3>Meeting Culture</h3>
          <p>Your preference for meeting frequency</p>
        </IonLabel>
        <IonSelect
          value={data.meeting_culture || ''}
          placeholder="Select meeting culture"
          onIonChange={(e) => handleFieldChange('meeting_culture', e.detail.value)}
        >
          {MEETING_CULTURES.map((option) => (
            <IonSelectOption key={option.value} value={option.value}>
              {option.label}
            </IonSelectOption>
          ))}
        </IonSelect>
      </IonItem>
    </IonList>
  );
};

export default WorkStylePreferenceEditor;
